var slider = (function(window, document, $, undefined) {
  return {
    init: function () {
      var swiper = new Swiper('.main-slider', {
        loop      : true,
        speed     : 1000,
        autoplay  : true,
        delay     : 5000,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });

      var galleryTop = new Swiper('.product-detail-slider', {
        nextButton  : '.swiper-button-next',
        prevButton  : '.swiper-button-prev',
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });


      var $thumbs = $('#js-product-detail-slider').find('.slider-thumb');
      $thumbs.on('click', function () {
        $thumbs.removeClass('active');
        $(this).addClass('active');
        galleryTop.slideTo($(this).index());
      });

      galleryTop.on('slideChange',function() {
        $thumbs.removeClass('active');
        $($thumbs[this.activeIndex]).addClass('active');
      })
    }
  };

})(window, document, jQuery, slider);

var templateScripting = (function(window, document, $, undefined) {
  return {
    init: function() {
      $(document).foundation();
    }
  }
})(window, document, jQuery, templateScripting);


var stickyHeader = (function(window, document, $, undefined) {
  return {
    $selector:    null,
    $window:      null,
    headerOffset:  0,

    init: function () {
      this.$selector =  $('.js-sticky-header');
      this.$window = $(window);
      if (this.$selector.length) {
        this.headerOffset = this.$selector.outerHeight();
        this.bindScrolling();
      }
    },
    bindScrolling: function() {
      var _this = this;
      this.$window.on('scroll', _.throttle(function() {
        if (_this.$window.scrollTop() > _this.headerOffset) {
          _this.toggleHeaderState(true);
        } else {
          _this.toggleHeaderState(false);
        }
      }, 100));
    },
    toggleHeaderState: function(collapse) {
      if (collapse) {
        if (!this.$selector.hasClass('collapsed')) {
          this.$selector.addClass('collapsed');
        }
      } else {
        this.$selector.removeClass('collapsed');
      }
    }
  }
})(window, document, jQuery, stickyHeader);



var mobileNavigation = (function(window, document, $, undefined){
  return {
    $body: null,
    $el: null,
    $btn: null,
    $items: null,
    options: {
      activeClassName: 'show',
      btnActiveClassName: 'menu-opened',
      bodyActiveClassName: 'mobile-menu-opened',
      itemSubmenuClassName: 'is-accordion-submenu-parent'
    },
    init: function () {
      var _this = this;
      _this.$body   = $('body');
      _this.$el     = $('.js-mobile-menu');
      _this.$btn    = $('.js-mobile-menu-btn');
      _this.$items  = $('.js-mobile-menu .mobile-navigation > ul > li');

      _this.$btn.on('click', function (e) {
        e.preventDefault();
        _this.toggleMobileMenu();
      });

      _this.$items.on('click', function (e) {
        if (!$(e.currentTarget).hasClass(_this.options.itemSubmenuClassName)) {
          _this.closeMenu();
        }
      });

    },
    toggleMobileMenu: function() {
      if (this.$el.hasClass(this.options.activeClassName)) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
    closeMenu: function() {
      this.$el.removeClass(this.options.activeClassName);
      this.$btn.removeClass(this.options.btnActiveClassName);
      this.$body.removeClass(this.options.bodyActiveClassName);
      //window.iv.appPlugins.fullPageScroll.enableScrolling();
    },
    openMenu: function() {
      this.$el.addClass(this.options.activeClassName);
      this.$btn.addClass(this.options.btnActiveClassName);
      this.$body.addClass(this.options.bodyActiveClassName);
      //window.iv.appPlugins.fullPageScroll.disableScrolling();
    }
  }
})(window, document, jQuery, mobileNavigation);




// WEBPACK FOOTER //
// src/assets/js/scripting.js